import { useEffect } from 'react';

export default (condition = true) => {
  useEffect(() => {
    condition && document?.body.classList.add('no-scroll');
    !condition && document?.body.classList.remove('no-scroll');
    return () => condition && document.body.classList.remove('no-scroll');
  }, [condition]);
};
